export default __webpack_public_path__ + "static/media/column-unsorted.b29b83ee.svg";